import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

export const messages: {
	unconnectedTitle: MessageDescriptor;
	unconnectedDescription: MessageDescriptor;
	connectButton: MessageDescriptor;
	connectedTitle: MessageDescriptor;
	connectedRerunDescription: MessageDescriptor;
	rerunPromptButton: MessageDescriptor;
	connectedDescription: MessageDescriptor;
} = defineMessages({
	unconnectedTitle: {
		id: 'ai-mate.conversation-assistant-ui-components.connector-recommendation.title',
		defaultMessage: 'Connect {appName}',
		description:
			'Title shown on a contextual recommendation card prompting the user to connect a third-party app to Rovo.',
	},
	unconnectedDescription: {
		id: 'ai-mate.conversation-assistant-ui-components.connector-recommendation.description',
		defaultMessage:
			'Your results may be missing info from {appName}. Connect to get more complete answers.',
		description:
			'Body text shown on the connector recommendation card explaining the benefit of connecting the third-party app.',
	},
	connectButton: {
		id: 'ai-mate.conversation-assistant-ui-components.connector-recommendation.connect-button',
		defaultMessage: 'Connect',
		description:
			'Label for the call-to-action button that begins the OAuth flow to connect a third-party app.',
	},
	connectedTitle: {
		id: 'ai-mate.conversation-assistant-ui-components.connector-recommendation.connected-title',
		defaultMessage: '{appName} is connected 🎉',
		description:
			'Card title shown after the user successfully connects a third-party app and can re-send their last message.',
	},
	connectedRerunDescription: {
		id: 'ai-mate.conversation-assistant-ui-components.connector-recommendation.connected-description',
		defaultMessage:
			'Rovo can now search your {appName} for answers. Re-send your last message to see better results.',
		description:
			'Card description shown after the user successfully connects a third-party app and can re-send their last message.',
	},
	rerunPromptButton: {
		id: 'ai-mate.conversation-assistant-ui-components.connector-recommendation.rerun-prompt-button',
		defaultMessage: 'Re-send message',
		description: 'CTA button label to re-send the last message after connecting a third-party app.',
	},
	connectedDescription: {
		id: 'ai-mate.conversation-assistant-ui-components.connector-recommendation.connected-simple-description',
		defaultMessage: 'Your answers now include results from {appName}.',
		description:
			'Card description shown after the user successfully connects a third-party app but has already sent a new message (no re-send CTA available).',
	},
});
